import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../../core';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';


@Component({
  selector: 'app-delete-property-dialog',
  templateUrl: './deletePropertyDialog.component.html',
  styleUrls: ['./deletePropertyDialog.component.scss']
})

export class DeletePropertyDialogComponent implements OnInit {
  constructor(
    private httpService: HttpService,
    private toastrService: ToastrService,
    private router: Router,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  delete() {
    console.log(this.data.propertyId);
    this.httpService.deleteProperty(this.data.propertyId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('The property has been deleted.');
        this.dialogRef.close({result: 1});
      } else if (res.code === -101) {
        this.toastrService.error('The property has foreign key related');
        this.dialogRef.close({result: 1});
      }
      else {
        this.toastrService.error('Failed to delete this property.');
        this.dialogRef.close({result: 0});
      }
    });
  }
}
